/**
 * The bearer token for requests. The web app has none: the browser sends the http-only session
 * cookie with each request, so this always resolves to null. Kept as the one place callers ask.
 */
const getPieveAuthToken = async () => null;

export default getPieveAuthToken;
